module.exports = __webpack_public_path__ + "img/AddressInfo.390eeb68.svg";